import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';

import { Checkbox } from '@gogame/components';

import { omitFormProps } from '../utils';
import withFormField from './withFormField';

const FormCheckboxField = withFormField()(({ value = false, ...props }) => {
  return <Checkbox checked={value} {...omitFormProps(props)} />;
});

export default hoistNonReactStatics(FormCheckboxField, Checkbox);
